import { render, staticRenderFns } from "./WorkInformation.vue?vue&type=template&id=0d455587&scoped=true"
import script from "./WorkInformation.vue?vue&type=script&lang=js"
export * from "./WorkInformation.vue?vue&type=script&lang=js"
import style0 from "./WorkInformation.vue?vue&type=style&index=0&id=0d455587&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d455587",
  null
  
)

export default component.exports